import React from 'react';
import Icon from '../Icon';
import useClasses from '../../hooks/useClasses';

import './style.scss';

interface Props {
  exerciseId: string
  icon: string
  title: string
  isComplete: boolean
  position?: 'first' | 'last' | 'only'
  onClick?: (exerciseId: string) => void
}

const ExerciseTeaser: React.FC<Props> = ({
  exerciseId,
  icon,
  title,
  isComplete,
  position,
  onClick,
}) => {
  const { buildClass, joinClasses } = useClasses('ExerciseTeaser', {
    'is-complete': isComplete,
    'is-first-of-phase': position === 'first' || position === 'only',
    'is-last-of-phase': position === 'last' || position === 'only',
  });

  return (
    <div className={buildClass()}>
      <div className={buildClass('progress-line', 'top')} />
      <div className={buildClass('progress-line', 'bottom')} />
      <button
        type="button"
        className={joinClasses(buildClass('inner'), { disabled: !isComplete })}
        disabled={!onClick}
        onClick={() => {
          if (onClick) {
            onClick(exerciseId);
          }
        }}
      >
        <div className={buildClass('icon-container')}>
          <div className={buildClass('icon-container__inner')}>
            <Icon icon={icon} variant="4" />
          </div>
        </div>
        <h3 className={buildClass('title')}>{title}</h3>
      </button>
    </div>
  );
};

export default ExerciseTeaser;
